import React from 'react';
import { PRODUCT_VARIANTS } from '../../data/cta-variants';
import { ArticleSection } from '../../components/ArticleSection';
import { ArticleBodyComponent } from '../../components/ArticleBodyComponent';
import { BehaviorHeader } from './components/BehaviorHeader';
import { ArticleShareIcons } from '../../components/ArticleShareIcons';
import { NeedAdviceBanner } from '../../components/NeedAdviceBanner';
import { RotatingBouncer } from '../../components/RotatingBouncer';
import { CamelizedBehaviorArticleResponse } from '../../types/api';
import { BehaviorCmsComponents } from '../../constants';
import { Container } from '../../wag-react/components/Container';
import { Box } from '../../wag-react/next-components/box';
import { AuthorBlock } from '../../wag-react/components/author-block/AuthorBlock';
export type BehaviorPageContainerProps = CamelizedBehaviorArticleResponse & {
  slug: string;
};
export const BehaviorPageContainer = (props: BehaviorPageContainerProps) => {
  const {
    body,
    author,
    shareUrls,
    title
  } = props;
  return <>
      <Container as="article" maxWidth="832px" position="relative" px={['unset', '24px']} data-sentry-element="Container" data-sentry-source-file="index.tsx">
        <ArticleShareIcons value={shareUrls} title={title} data-sentry-element="ArticleShareIcons" data-sentry-source-file="index.tsx" />

        <BehaviorHeader {...props} data-sentry-element="BehaviorHeader" data-sentry-source-file="index.tsx" />

        <ArticleSection id="main-section" as="section" data-sentry-element="ArticleSection" data-sentry-source-file="index.tsx">
          {body.map(item => <Box key={String(item)} px={[item.type === 'component' ? 'unset' : '16px', 'unset']}>
              <ArticleBodyComponent key={JSON.stringify(item)} value={item} overrides={{
            component: data => {
              if (data.component === BehaviorCmsComponents.NeedAdviceBanner && data.props.isEnabled) {
                return <NeedAdviceBanner my="40px" {...data.props} />;
              }
              return null;
            }
          }} />
            </Box>)}
        </ArticleSection>

        {author && <AuthorBlock as="address" fontStyle="normal" value={author} px={['16px', 'unset']} mb="30px" />}

        {/* Removing for now as we don't support temporarily */}
        {/* <BehaviorCommentsSection
          {...props}
         /> */}
      </Container>
      <RotatingBouncer variants={PRODUCT_VARIANTS} contentType="behavior_guide" data-sentry-element="RotatingBouncer" data-sentry-source-file="index.tsx" />
    </>;
};